import { ArrowDownUp, ChevronDownIcon, Trash2 } from "lucide-react";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

const actionsList = [
  { label: "ثبت کسری بار", value: "/CargoDeficitFare" },
  { label: "ثبت کالا", value: "/list/guarantee" },
  { label: "لیست کسری بار", value: "/register/load" },
  { label: "لیست کالا", value: "/final/bill" },
];

interface ColumnProps {
  onClickDelete: (data: any) => void;
  handlerUpdate: (data: any) => void;
}
// {

const CargoColumn = ({ onClickDelete, handlerUpdate }: ColumnProps) => {
  const CargoColumn = useMemo(
    () => [
      {
        header: () => (
          <span className="flex">
            نام راننده
            <ArrowDownUp size={15} className="text-blue-500 gap-2" />
          </span>
        ),
        accessorKey: "commitment_number",
        enableColumnFilter: true,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "همراه راننده",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
      },
      {
        header: "شماره بارنامه",
        accessorKey: "farmer_name",
        enableColumnFilter: false,
      },
      {
        header: "عیار",
        accessorKey: "village_name",
        enableColumnFilter: true,
      },
      {
        header: () => (
          <span className="flex">
            وزن بار
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),
        accessorKey: "amount_of_land",
        enableColumnFilter: true,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span className="flex">
            وزن خاک
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),
        accessorKey: "withdrawal_amount",
        enableColumnFilter: true,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "درصد افت",
        accessorKey: "date_set",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "قیمت واحد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "کرایه حمل",
        accessorKey: "dsdd",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "کمک کرایه حمل بار",
        accessorKey: "dsadsdas",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "بهایه قند سهمیه",
        accessorKey: "ssdsdsds",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "بهای تفاله چغندر",
        accessorKey: "ssdsdsds523dsa",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "جمع کل",
        accessorKey: "dsdsdsda",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ تحویل",
        accessorKey: "sasasafdwfw2",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "کارخانه",
        accessorKey: "41ds2s12d",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ ثبت",
        accessorKey: "dasdfa244wq212q",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        accessorKey: "actions",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const rowData = cell.row.original;
          const rowId = rowData.id;

          const handleChange = (selected: any) => {
            if (selected?.value) {
              const isRegisterAction =
                selected.value.includes("/register") ||
                selected.value.includes("/PoisonDelivery");

              const finalUrl = isRegisterAction
                ? `${selected.value}/${rowId}`
                : selected.value;
              // toast.warn("با عرض پوزش این صفحه در حال توسعه میباشد");
              window.location.href = finalUrl;
            }
          };

          const customStyles = {
            control: (provided: any, state: any) => ({
              ...provided,
              backgroundColor: state.isFocused ? "white" : "white",
              borderColor: state.isFocused ? "#3b82f6" : "#e5e7eb",
              boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "none",
              "&:hover": {
                borderColor: "#3b82f6",
              },
              padding: "0.25rem",
              fontSize: "0.875rem",
              borderRadius: "0.375rem", // rounded-md
              minHeight: "auto",
            }),
            menu: (provided: any) => ({
              ...provided,
              zIndex: 9999,
              marginTop: "0.25rem",
              borderRadius: "0.375rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
            }),
            option: (provided: any, state: any) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? "#2563eb"
                : state.isFocused
                ? "#dbeafe"
                : "white",
              color: state.isSelected
                ? "white"
                : state.isFocused
                ? "#1e3a8a"
                : "#1f2937",
              padding: "0.5rem 0.75rem",
              "&:active": {
                backgroundColor: "#2563eb",
              },
            }),
            dropdownIndicator: (provided: any) => ({
              ...provided,
              padding: "0 0.5rem",
            }),
            indicatorSeparator: () => ({
              display: "none",
            }),
          };

          return (
            <div className="max-w-[150px]">
              <Select
                options={actionsList}
                placeholder="انتخاب کنید..."
                onChange={handleChange}
                isSearchable={false}
                styles={customStyles}
                className="text-sm"
                classNamePrefix="select"
                menuPortalTarget={document.body} // برای حل مشکل z-index
                menuPosition="fixed" // برای موقعیت دهی بهتر
                components={{
                  DropdownIndicator: () => (
                    <div className="pr-2">
                      <ChevronDownIcon className="h-4 w-4 text-gray-500" />
                    </div>
                  ),
                }}
              />
            </div>
          );
        },
      },
      {
        header: "حذف/ویرایش",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link
              to="#!"
              className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                handlerUpdate(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-green-600 text-white">
                ویرایش
              </span>
            </Link>
            <Link
              to="#!"
              className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </Link>
          </div>
        ),
      },
    ],
    []
  );
  return CargoColumn;
};

export default CargoColumn;
